module.exports = __webpack_public_path__ + "static/img/E004.2952465.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/E004.jpg
// module id = 7ROM
// module chunks = 1